import { render, staticRenderFns } from "./DiplomaForm.vue?vue&type=template&id=b2f98f5e&scoped=true&"
import script from "./DiplomaForm.vue?vue&type=script&lang=js&"
export * from "./DiplomaForm.vue?vue&type=script&lang=js&"
import style0 from "./DiplomaForm.vue?vue&type=style&index=0&id=b2f98f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f98f5e",
  null
  
)

export default component.exports